module.exports = __webpack_public_path__ + "img/promo.327146a.jpg";